import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import { CollectionsByMembershipSelectorConfig } from '@ilteducation/content-views-types/collections-selectors/config';
import type { MemberRole } from '@ilteducation/content-collections-types';
type Props = {
  id: string;
  config: CollectionsByMembershipSelectorConfig;
  subscription: string;
  text?: string;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'CollectionByMembership',
  props: {
    id: null,
    config: null,
    subscription: null,
    text: null
  },
  emits: ["update-collection"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'update-collection', id: string, config: CollectionsByMembershipSelectorConfig): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  id: string;
  config: CollectionsByMembershipSelectorConfig;
  subscription: string;
  text?: string;
}



const chosenSelector = ref(props.config.role ?? null);
const membershipsSelectors: CollectionsByMembershipSelectorConfig[] = [
  {
    type: 'CollectionsByMembershipSelector',
    role: 'owner' as MemberRole.Owner,
    context: props.subscription,
  },
  {
    type: 'CollectionsByMembershipSelector',
    role: 'member' as MemberRole.Member,
    context: props.subscription,
  },
  {
    type: 'CollectionsByMembershipSelector',
    role: 'subscriber' as MemberRole.Subscriber,
    context: props.subscription,
  },
];
const change = () => {
  emits(
    'update-collection',
    props.id,
    membershipsSelectors.find((s) => s.role === chosenSelector.value),
  );
};

return { __sfc: true,emits, props, chosenSelector, membershipsSelectors, change }
}

})